import React, { useCallback, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import useAppNavigation from '~/hooks/useAppNavigation';

import { type IAppName } from '~/services/AwsJobsService';

import AwsJobsPageContainer from './PageContainer';
import { DERBYSOFT_TYPE, PUBLIC_OFFERS_TYPE, RATEDOCK_TYPE, RENTALSUNITED_TYPE } from './constants';

function AwsJobsPage() {
  const { replace } = useAppNavigation();
  const location = useLocation();

  const getInitialTab = useCallback(() => {
    const hash = location.hash.replace('#', '');
    return (hash || PUBLIC_OFFERS_TYPE) as IAppName;
  }, [location.hash]);

  const [selectedTab, setSelectedTab] = useState<IAppName>(getInitialTab);

  const handleTabChange = useCallback(
    (_, value) => {
      setSelectedTab(value);

      replace({
        pathname: location.pathname,
        search: value !== PUBLIC_OFFERS_TYPE ? location.search : '',
        hash: value,
      });
    },
    [replace, location.pathname, location.search],
  );

  return (
    <>
      <Container maxWidth="xl">
        <Helmet>
          <title>AWS Jobs</title>
        </Helmet>
        <PageHeader title="AWS Jobs" />
        <Tabs sx={{ mb: 2 }} value={selectedTab} onChange={handleTabChange}>
          <Tab key={PUBLIC_OFFERS_TYPE} value={PUBLIC_OFFERS_TYPE} label="Public Offers" />
          <Tab key={DERBYSOFT_TYPE} value={DERBYSOFT_TYPE} label="Derbysoft" />
          <Tab key={RATEDOCK_TYPE} value={RATEDOCK_TYPE} label="Ratedock" />
          <Tab key={RENTALSUNITED_TYPE} value={RENTALSUNITED_TYPE} label="Rentalsunited" />
        </Tabs>

        <AwsJobsPageContainer selectedTab={selectedTab} />
      </Container>
    </>
  );
}

export default AwsJobsPage;
